import React from 'react';

export default class Page3 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">

                                        <div className="ilead-contentarea">
                                            <div className="border_subtitle">Clear, concise and relevant</div>
                                            <p>Use clear, straightforward language and avoid jargon which may
                                                confuse or irritate whoever’s listening. Make it concise and
                                                relevant – digressions can be illustrative or serve to add
                                                interest, but expansive detail and irrelevance will frustrate
                                                and bore. Avoid repetitions and catchphrases – many of us use a
                                                certain phrase habitually (‘d’you know what I mean’, for
                                                example) without
                                                realising it!</p>
                                            <div className="border_subtitle">Rapport</div>
                                            <p>If the audience can relate to you personally, as well as to what
                                                you’re saying, they’ll be more
                                                receptive. To learn more about this, see our tool ‘How to
                                                develop rapport’.</p>
                                            <div className="border_subtitle">Credibility</div>
                                            <p>Again, if you behave and sound as if you’re trustworthy and know
                                                what you’re talking about,
                                                people are more likely to trust you in return, by ‘buying-in’ to
                                                your message. Research reveals that
                                                people are more compliant when spoken to by ‘authoritative’
                                                figures, which includes sounding
                                                authoritative, or ‘expert’ in whatever you’re talking about. For
                                                example, a recent study<a className="superscripttext"
                                                                          href="further_info.php?course=300"><sup>4</sup></a> showed
                                                this is how many religious leaders influence their followers’
                                                beliefs.</p>
                                            <div className="border_subtitle">Confidence</div>
                                            <p>It’s not very helpful simply to advise you to be confident if
                                                you’re anxious or worried about
                                                communicating. Think of it like this: If you’re confident in
                                                your message it will translate to your
                                                audience, which is more important than worrying about what
                                                people will think about your left
                                                profile or whether the stripy socks were a mistake. There’s a
                                                curious but proven phenomenon
                                                called the Pygmalion effect<a className="superscripttext"
                                                                              href="further_info.php?course=300"><sup>4</sup></a> which
                                                stems from research into how expectation affects outcome. A
                                                recent study showed that when workers in Japan expected a
                                                project to go well, they performed
                                                better. In other words, if you expect things to go badly, you’re
                                                increasing that likelihood. Instead,
                                                just prepare well, believe in what you’re saying and expect it
                                                to go well!</p>
                                            <div className="border_subtitle">Tone and body language</div>
                                            <p>While your message is the most important aspect of your
                                                communication, your tone and body
                                                language also give subtle messages, so make sure the way you
                                                behave doesn’t contradict your
                                                intention. Maintain an open expression, don’t avoid eye contact
                                                or give the impression you’d
                                                rather be anywhere other than talking to the person or people in
                                                front of you.<a className="superscripttext"
                                                                href="further_info.php?course=300"><sup>5</sup></a>
                                            </p>
                                            <div className="border_subtitle">Memorability</div>
                                            <p>What we’ve advised so far is all very well, but not much use if
                                                what you have to say to people
                                                seems to go in one ear and out the other. It is important to
                                                have techniques for making your
                                                communication memorable.</p>
                                            <div className="paraspace"><p>Firstly, think about the structure.
                                                Bear in mind that it’s the start and end of any communication
                                                that’s remembered most, whether it’s a speech, presentation or
                                                an explanation – so don’t
                                                sandwich the important part of what you have to say between a
                                                long winded, less relevant
                                                opening and finish. Again, there’s an effective theory about
                                                this called the ‘Primacy-Recency Effect’<a
                                                    className="superscripttext"
                                                    href="further_info.php?course=300"><sup>6</sup></a> to help
                                                you structure your message. It goes like this:</p></div>
                                            <ul className="greenbullet-list">
                                                <li>Tell them what you’re going to tell them</li>
                                                <li>Tell them</li>
                                                <li>Tell them what you told them.</li>
                                            </ul>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page2')}
                                                    className="button-next-previous-done">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div onClick={this.props.handleChangePage('Page4')}
                                                     className="button-next-previous-done">Next &gt;&gt;</div>
                                            </div>


                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>


                    </div>
                </div>
            </div>
        </div>;
        ;
    }
}